"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LockOutlined = _interopRequireDefault(require("@material-ui/icons/LockOutlined"));
var _core = require("@material-ui/core");
var _formik = require("formik");
var _formFields = require("react-platform-components/dist/form-fields");
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var Yup = _interopRequireWildcard(require("yup"));
var _Translations = require("react-platform-components/dist/Translations");
var _formValidators = require("react-platform-components/dist/form-validators");
var _config = require("../config");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    '@global': {
      body: {
        backgroundColor: theme.palette.common.white
      }
    },
    paper: {
      marginTop: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main
    },
    form: {
      width: '100%',
      // Fix IE 11 issue.
      marginTop: theme.spacing(1)
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
      padding: '.8rem'
    },
    container: {
      padding: '5px 40px',
      boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
      marginTop: theme.spacing(8)
    }
  };
});
function ForgotPassword(props) {
  var classes = useStyles();
  var inProgress = (0, _reactRedux.useSelector)(function (_ref) {
    var forgotPasswordReducer = _ref.forgotPasswordReducer;
    return forgotPasswordReducer.inProgress;
  });
  var dispatch = (0, _reactRedux.useDispatch)();
  var handlerCloseSnackbar = function handlerCloseSnackbar(event) {
    dispatch({
      type: 'CLEAR_ERROR'
    });
  };
  var formik = (0, _formik.useFormik)({
    initialValues: {
      email: ''
    },
    onSubmit: function onSubmit(values) {
      dispatch({
        type: 'FORGET_PASSWORD',
        model: values,
        history: props.history
      });
    }
  });
  return /*#__PURE__*/_react.default.createElement(_core.Container, {
    component: "main",
    maxWidth: "xs",
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_core.CssBaseline, null), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.paper
  }, _config.LOGO_PATH && _config.LOGO_LINK && _config.LOGO_LINK_URL ? /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(_config.BASE_URL).concat(_config.LOGO_LINK_URL)
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _config.LOGO_PATH,
    alt: "Medialem",
    width: "220"
  })) : _config.LOGO_PATH && _config.LOGO_LINK ? /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(_config.BASE_URL)
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _config.LOGO_PATH,
    alt: "Medialem",
    width: "220"
  })) : /*#__PURE__*/_react.default.createElement(_core.Link, {
    href: "/",
    className: "pb-4"
  }, _config.NAVBAR_LOGO_PATH ? /*#__PURE__*/_react.default.createElement("img", {
    src: _config.NAVBAR_LOGO_PATH,
    alt: "",
    width: "180"
  }) : /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.avatar
  }, /*#__PURE__*/_react.default.createElement(_LockOutlined.default, null))), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "h1",
    variant: "h5"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Forgot password",
    defaultMessage: "Forgot password"
  })), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_formik.FormikContext.Provider, {
    value: formik
  }, /*#__PURE__*/_react.default.createElement("form", {
    className: classes.form,
    noValidate: true,
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "email",
    label: "Email Address",
    variant: "outlined",
    margin: "normal",
    fullWidth: true,
    validate: (0, _formValidators.required)()
  }), /*#__PURE__*/_react.default.createElement(_core.Button, {
    type: "submit",
    fullWidth: true,
    variant: "contained",
    color: "primary",
    className: classes.submit,
    disabled: inProgress
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Submit",
    defaultMessage: "Submit"
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/login",
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Login",
    defaultMessage: "Login"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/register",
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Don't have an account? Sign Up",
    defaultMessage: "Don't have an account? Sign Up"
  })))))))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 5
  }));
}
var _default = (0, _reactRouterDom.withRouter)(ForgotPassword);
exports.default = _default;